export const nulinga = {
  text: 'Test de Nivelación de Inglés',
  notCompletedText: 'Si todavía no lo completaste, haz',
  linkRef: 'https://nulinga.com/postulantes/new?token=MrG',
}
